import {useState} from 'react'
import {SidebarMenuItem} from '../SidebarMenuItem'
import {useDispatch, useSelector} from 'react-redux'
import {getCompanyState} from '../../../../redux/companySlice'
import {Api_Company_ScoreAdvisor} from '../../../../apiClient/apiClient'
import {postRequestAsync} from '../../../../redux/commonSlice'
import {BooleanApiData, ScoreAdvisorRequest} from '../../../../api/data-contracts'

const SidebarCustomerMenu = () => {
  const dispatch = useDispatch()
  const companyState = useSelector(getCompanyState)
  const [score, setScore] = useState<number>(companyState.data?.financialAdvisor?.userScore ?? 0)
  const [hoverScore, setHoverScore] = useState<number>(0)
  const [scoreMessage, setScoreMessage] = useState<{text: string; success: boolean} | null>(null)

  return (
    <>
      {companyState.data?.company?.isWizardFinished == false && (
        <SidebarMenuItem
          to='/wizard'
          title='KURULUM_VE_PAKET'
          icon='/media/icons/duotune/general/gen022.svg'
        />
      )}

      {companyState.data?.company?.isWizardFinished == true && (
        <>
          {process.env.REACT_APP_ENV != 'PROD' && (
            <SidebarMenuItem
              to='/home'
              title='ANASAYFA'
              icon='/media/icons/duotune/abstract/abs027.svg'
            />
          )}

          <SidebarMenuItem
            to='/extra'
            title='EK_COZUMLER'
            icon='/media/icons/duotune/abstract/abs027.svg'
          />

          <SidebarMenuItem
            to='/finance'
            title='ON_MUHASEBE'
            icon='/media/icons/duotune/finance/fin007.svg'
          />
          <SidebarMenuItem
            to='/services'
            title='ABONELIK_VE_ODEME'
            icon='/media/icons/duotune/finance/fin008.svg'
          />

          {companyState.data?.company?.isActive && (
            <SidebarMenuItem
              to='/documents'
              title='DOSYALAR'
              icon='/media/icons/duotune/files/fil016.svg'
            />
          )}

          {process.env.REACT_APP_ENV != 'PROD' && (
            <SidebarMenuItem
              to='/notification'
              title='NOTIFICATION_TEST'
              icon='/media/icons/duotune/general/gen022.svg'
            />
          )}
        </>
      )}

      <SidebarMenuItem
        to='/profile'
        title='PROFIL_AYARLARI'
        icon='/media/icons/duotune/coding/cod001.svg'
      />

      {/* {companyState.data?.financialAdvisor && (
        <div className='px-5 py-4 mt-auto'>
          <div className='border-top pt-4'>
            <div className='text-muted fs-8 fw-semibold text-uppercase mb-1'>Mali Müşavir</div>
            <div className='text-gray-800 fs-7 fw-bold'>
              {companyState.data?.financialAdvisor?.name}
            </div>
            <div className='d-flex align-items-center justify-content-between mt-2'>
              <div className='d-flex align-items-center'>
                {[1, 2, 3, 4, 5].map((star) => {
                  const displayScore = hoverScore || score
                  const iconClass =
                    displayScore >= star
                      ? 'fa-solid fa-star text-warning'
                      : 'fa-regular fa-star text-warning'
                  return (
                    <i
                      key={star}
                      className={`${iconClass} fs-6 me-1 cursor-pointer`}
                      onMouseEnter={() => setHoverScore(star)}
                      onMouseLeave={() => setHoverScore(0)}
                      onClick={() => setScore(star)}
                    />
                  )
                })}
              </div>
              <button
                className='btn btn-sm btn-light-primary py-1 px-3'
                disabled={score === 0}
                onClick={async () => {
                  setScoreMessage(null)
                  try {
                    const body: ScoreAdvisorRequest = {scorePoint: score}
                    const result = await dispatch<any>(
                      postRequestAsync({
                        postRequestFunction: Api_Company_ScoreAdvisor,
                        body,
                      })
                    ).unwrap()
                    if (result?.data) {
                      setScoreMessage({text: 'Puanlamanız kaydedildi!', success: true})
                    } else {
                      setScoreMessage({text: 'Bir hata oluştu.', success: false})
                    }
                  } catch {
                    setScoreMessage({text: 'Bir hata oluştu.', success: false})
                  }
                }}
              >
                Puanla
              </button>
            </div>
            {scoreMessage && (
              <div className={`fs-9 mt-1 ${scoreMessage.success ? 'text-success' : 'text-danger'}`}>
                {scoreMessage.text}
              </div>
            )}
          </div>
        </div>
      )} */}
    </>
  )
}

export {SidebarCustomerMenu}
